function onUpcartPopupShow() {
  const close_btn = document.querySelector(".product-block.expanded .close-detail");
  if(close_btn) close_btn.click();
}

const observer = new MutationObserver((mutations) => {
  for (const mutation of mutations) {
    if (mutation.attributeName === "class") {
      const bodyClassList = document.body.classList;
      if (bodyClassList.contains("upcartPopupShow")) {
        onUpcartPopupShow();
      }
    }
  }
});

observer.observe(document.body, {
  attributes: true,
  attributeFilter: ["class"],
});
